import { makeStyles } from "@material-ui/core/styles";

export const styles = style =>
  style
    ? makeStyles(theme => ({
        ...style(theme),
      }))()
    : {};

export default styles;
